import axios from "axios"

import { ITmsPartSearchInput } from "@/types";

export const TmsService = Object.freeze({
  GetOems: function (input: ITmsPartSearchInput ) {
    var reqUrl = `${window.appGlobals.API_URL}Tms/GetTmsOems`
    return axios.post(reqUrl, input)
  },
  GetModels: function (input: ITmsPartSearchInput) {
    var reqUrl = `${window.appGlobals.API_URL}Tms/GetTmsModels`
    return axios.post(reqUrl, input)
  },
  GetCategories: function(input: ITmsPartSearchInput){
    var reqUrl = `${window.appGlobals.API_URL}Tms/GetTmsCategories`
    return axios.post(reqUrl, input)
  },
  GetPartSearchResults: function (input: ITmsPartSearchInput) {
    var reqUrl = `${window.appGlobals.API_URL}Tms/GetPartSearchResults`;
    return axios.post(reqUrl, input);
  }
})
